import { useTranslation } from 'react-i18next'

import { FeatureCard } from './FeatureCard'
import { PlateScore } from '@/components/plates/PlateScore'
import { PlateSignals } from '@/components/plates/PlateSignals'
import { PlateTouch } from '@/components/plates/PlateTouch'
import { SectionHeader } from './SectionHeader'
import styles from './FeatureList.module.scss'

/**
 * Three steps, one story, in the hero's own language: signals → score → first touch. The plates
 * share a register and a hub, which is what makes them read as one set rather than three drawings.
 * The 46px icon tiles are gone: a pictogram of signals under a 160px illustration of signals said
 * the same thing twice.
 */
const FEATURES = [
  { key: 'signals', plate: <PlateSignals /> },
  { key: 'score', plate: <PlateScore /> },
  { key: 'touch', plate: <PlateTouch /> },
] as const

export const FeatureList = () => {
  const { t } = useTranslation()

  return (
    <section id="features" className={styles.root}>
      <SectionHeader
        kicker={t('landing.features.kicker')}
        title={t('landing.features.title')}
        lede={t('landing.features.lede')}
      />
      <div className={styles.grid}>
        {FEATURES.map((feature) => (
          <FeatureCard
            key={feature.key}
            plate={feature.plate}
            title={t(`landing.features.${feature.key}.title`)}
            text={t(`landing.features.${feature.key}.text`)}
          />
        ))}
      </div>
    </section>
  )
}
